import { baseService } from 'services';
import { ReliantResponse } from 'interface/apiInterface';
import { listAppsEP, getAppEP } from 'services/constants';
import {
  IGetAppRequest,
  IGetAppResponse,
  IListAppRequest,
  IListAppResponse,
} from 'interface/appInterface';
import { AxiosError } from 'axios';

export const listApps = async (
  data: IListAppRequest,
): Promise<ReliantResponse<IListAppResponse>> => {
  try {
    const response = await baseService.post<IListAppResponse>(listAppsEP, data);
    return new ReliantResponse(response);
  } catch (error) {
    return new ReliantResponse(undefined, error as AxiosError);
  }
};

export const getApp = async (
  data: IGetAppRequest,
): Promise<ReliantResponse<IGetAppResponse>> => {
  try {
    const response = await baseService.post<IGetAppResponse>(getAppEP, data);
    return new ReliantResponse(response);
  } catch (error) {
    return new ReliantResponse(undefined, error as AxiosError);
  }
};
